import NewUser from "./NewUser"
import "./newUser.scss"

export default NewUser
